import React from 'react';

const Title = () => {
  return (
    <div className="title">
      <h1>PocoGram</h1>
      <h2>Your Pictures</h2>
      <p>the visual percept of a region</p>
    </div>
  )
}

export default Title;